import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { useRouter } from 'next/navigation';

import { Icon } from '@/components/ui/icon.component';
import { SheetClose, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { removeRegistrationStorage } from '@/storage/registration.storage';
import { useProgressiveModal } from '@/components/ui/progressive-modal/progressive-modal.hook';
import LoginForm from '@/app/(main)/_components/sign-in-modal/_components/login-form.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';

export default function LoginStep() {
  const { onClose } = useProgressiveModal();
  const router = useRouter();

  const handleCreateAccount = () => {
    removeRegistrationStorage();
    onClose?.();
    router.push('/cadastro/');
  };

  return (
    <div className="flex flex-col h-full md:max-h-[40rem]" data-testid="login-div--login-step">
      <SheetHeader className="bg-white">
        <div className="flex justify-between gap-3 pb-4 items-center">
          <div className="flex gap-3">
            <SheetTitle>
              <div className="flex gap-3">
                <Typography variant={TypographyVariant.MODAL_TITLE}>Entrar</Typography>
              </div>
            </SheetTitle>
          </div>
          <SheetClose
            asChild
            className="text-gray-500 cursor-pointer self-center px-2 hover:bg-gray-50"
            onClick={onClose}
          >
            <Icon icon={faTimes} size="xl" className="hover:text-gray-900 text-[1.625rem]" />
          </SheetClose>
        </div>
      </SheetHeader>
      <div className="flex flex-col gap-6">
        <LoginForm />
        <div className="flex flex-col items-center gap-1">
          <p className="text-gray-800 font-normal leading-5">Ainda não possui conta?</p>
          <p className="text-green-500 font-semibold leading-6 cursor-pointer" onClick={handleCreateAccount}>
            Cadastre-se
          </p>
        </div>
      </div>
    </div>
  );
}
